import { BellIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { memo } from 'react'

const NotificationEmptyBase: React.FC = (): ReactNode => {
  return (
    <div className="notification-empty flex flex-col items-center justify-center py-8 px-4">
      <BellIcon className="size-10 text-muted-foreground/50 mb-2" />
      <p className="text-sm text-muted-foreground">No notifications</p>
    </div>
  )
}

export const NotificationEmpty = memo(NotificationEmptyBase)

NotificationEmpty.displayName = 'NotificationEmpty'
